import { defineStore } from 'pinia';
import { giftWrapFormFields } from '~/modules/GraphQL/types';

interface giftWrapState {
  giftWrap: giftWrapFormFields,
}

export const useGiftWrapStore = defineStore('giftWrap', {
  state: (): giftWrapState => ({
    giftWrap: {
      isEnabled: false,
      needEmailReceiptInsteadPrinting: false,
      needPersonalMessage: false,
      personalMessage: '',
    },
  }),
});
